import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";

import {
  createGeneralInfo,
  getGeneralInfo,
  updateGeneralInfo,
} from "@api/general-info";

import {
  GeneralInfoActions,
  createGeneralInfoFailed,
  createGeneralInfoSuccess,
  getGeneralInfoFailed,
  getGeneralInfoSuccess,
  updateGeneralInfoFailed,
  updateGeneralInfoSuccess,
} from "@actions/HRM/employee/general-info-actions";
import {
  CREATE_GENERAL_INFO,
  GET_GENERAL_INFO,
  UPDATE_GENERAL_INFO,
} from "@actions/HRM/employee/types";

import { isRequestCancelled } from "@helpers/routing";
import { StoreType } from "@reducers/types";
import { GeneralInfoType } from "@type/HRM/general-info";

export const generalInfosMiddleware: Middleware<
  Record<string, unknown>,
  StoreType
> = ({ dispatch }: MiddlewareAPI) => {
  return (next: Dispatch<AnyAction>) => {
    return async (action: GeneralInfoActions) => {
      const nextAction = next(action);

      switch (action.type) {
        //CREATE
        case CREATE_GENERAL_INFO.CREATE_GENERAL_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const {
              dateOfDeath,
              lastPromotionDate,
              probationEndingDate,
              contractExpDate,
            } = payload.data as GeneralInfoType;

            const { data } = await createGeneralInfo({
              data: {
                ...payload.data,
                entryStatus: 0,
                isCreationDone: false,
                roomId: 0,
                roomDeskDetailsId: 0,
                entryStatusReferenceId: "string",
                postingPlaceId: 0,
                workingPlaceId: 0,
                dateOfDeath: dateOfDeath ? dateOfDeath : null,
                lastPromotionDate: lastPromotionDate ? lastPromotionDate : null,
                probationEndingDate: probationEndingDate
                  ? probationEndingDate
                  : null,
                contractExpDate: contractExpDate ? contractExpDate : null,
              },
            });

            dispatch(createGeneralInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              console.log("create general error", error);
              dispatch(createGeneralInfoFailed(error));
            }
          }
          break;
        }

        // FETCH
        case GET_GENERAL_INFO.GET_GENERAL_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await getGeneralInfo(payload);
            dispatch(getGeneralInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(getGeneralInfoFailed());
            }
          }
          break;
        }

        // UPDATE
        case UPDATE_GENERAL_INFO.UPDATE_GENERAL_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updateGeneralInfo(payload);

            dispatch(updateGeneralInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateGeneralInfoFailed(error));
            }
          }
          break;
        }
      }

      return nextAction;
    };
  };
};
